import React, { useEffect } from "react"
// import Image from "next/image"
import imgSustain from "assets/img/image/img_about-sustainability.png"

//Utils
import { useRouter } from "next/router"
import {
  useIsomorphicLayoutEffect,
  useScrollAnim,
} from "@components/hooks/hooks"
import { Image } from "@components/anti"

const SustainComp = ({ locale, locales }) => {
  //Utils
  const Router = useRouter()
  const [trigger, anim] = useScrollAnim()

  // useIsomorphicLayoutEffect(() => {
  //   document.documentElement.classList.add("enable-sticky")
  // }, [])
  //React Operations ******************************************************************** //

  return (
    <section className="sc-sustain" ref={trigger}>
      <div className="container">
        <div className={`row ${anim(1)} align-items-end`}>
          <div className="col-12 col-md-6 offset-md-1 wrapper-img order-md-2">
            <Image
              src={imgSustain}
              alt="about-sustain"
              placeholder="blur"
              className="img-sustain-about fadeInUp d2"
              ratio="r-1-1"
            />
          </div>
          <div className="col-12 col-md-4 offset-md-1 wrapper-content order-md-1">
            <h1 className={`title ${anim(2)}`}>Sustainability</h1>
            <h6 className={`text ${anim(3)}`}>
              We sourced sustainable natural material & undesired/unused
              production waste which usually rarley been used in production of
              bulk furnitures. Branch, roots, reclaimed woods, seagrass, etc are
              some of materials that we have been using in our product line up
            </h6>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SustainComp
